import React from "react";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { Button } from "@progress/kendo-react-buttons";
import { process } from "@progress/kendo-data-query";

export default class SalesRepsAdminGrid extends React.Component {
  constructor(props) {
    super(props);
    this._export = null;
    this.state = {
      data: (this.props.salesReps || []).slice(),
      dataState: {
        skip: 0,
        take: 20,
        sort: [{ field: "name", dir: "asc" }]
      },
      search: ""
    };
  }

  onDataStateChange = (e) => {
    this.setState({ dataState: e.dataState });
  };

  getFilteredData = () => {
    var data = this.state.data;
    var s = (this.state.search || "").toLowerCase();
    if (s) {
      data = data.filter(d =>
        (d.name || "").toLowerCase().indexOf(s) > -1 ||
        (d.email || "").toLowerCase().indexOf(s) > -1 ||
        (d.company || "").toLowerCase().indexOf(s) > -1
      );
    }
    return data;
  };

  onSearchChange = (e) => {
    this.setState({ search: e.target.value, dataState: { ...this.state.dataState, skip: 0 } });
  };

  onRefresh = () => {
    this.setState({
      dataState: { skip: 0, take: 20, sort: [{ field: "name", dir: "asc" }] },
      search: ""
    });
  };

  exportExcel = () => {
    if (this._export) this._export.save(this.getFilteredData());
  };

  impersonateUser = (userId, userEmail) => {
    if (!confirm("Sign in as " + userEmail + "?\n\nYou will be signed out of your admin account and signed in as this user. A banner at the bottom of every page will let you switch back.")) return;
    fetch("/api/Admin/ImpersonateUser", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId: userId })
    })
      .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, body: j }; }); })
      .then(function (r) {
        if (r.ok) { window.location.href = "/"; }
        else { alert(r.body.message || "Impersonation failed"); }
      })
      .catch(function (e) { alert("Error: " + e.message); });
  };

  render() {
    var filtered = this.getFilteredData();
    var processed = process(filtered, this.state.dataState);
    return (
      <div>
        <div className="quote-history-filters">
          <div className="quote-filter-item">
            <label>Search</label>
            <input
              type="text"
              value={this.state.search}
              onChange={this.onSearchChange}
              placeholder="Name, email, or company"
              style={{ minWidth: "240px" }}
            />
          </div>
        </div>
        <ExcelExport ref={(el) => (this._export = el)} fileName="SalesReps.xlsx">
          <Grid
            data={processed}
            {...this.state.dataState}
            onDataStateChange={this.onDataStateChange}
            sortable={true}
            pageable={{ pageSizes: [10, 20, 50] }}
            total={processed.total}
            style={{ height: "auto" }}
          >
            <GridToolbar>
              <button className="ui-button ink" onClick={this.exportExcel} style={{ background: "#333", color: "#fff" }}>
                Export to Excel
              </button>
              <button className="ui-button" onClick={this.onRefresh} style={{ marginLeft: "auto" }}>
                Refresh Grid
              </button>
            </GridToolbar>
            <GridColumn field="name" title="Name" width="140px"
              cell={(props) => (
                <td data-label="Name">
                  <a href={"/Admin/SalesReps/" + encodeURIComponent(props.dataItem.email)}>
                    {props.dataItem.name}
                  </a>
                </td>
              )}
            />
            <GridColumn field="email" title="Email" width="190px" />
            <GridColumn field="company" title="Company" />
            <GridColumn field="industryType" title="Industry" width="150px" />
            <GridColumn field="businessType" title="Type" width="100px" />
            <GridColumn field="dealerCount" title="Dealers" width="80px" filter="numeric"
              cell={(props) => (<td data-label="Dealers" style={{ textAlign: "right" }}>{props.dataItem.dealerCount}</td>)} />
            <GridColumn field="openQuotes" title="Open Quotes" width="100px" filter="numeric"
              cell={(props) => (<td data-label="Open Quotes" style={{ textAlign: "right" }}>{props.dataItem.openQuotes}</td>)} />
            <GridColumn field="pendingRegistrations" title="Pending" width="90px" filter="numeric"
              cell={(props) => (<td data-label="Pending" style={{ textAlign: "right" }}>{props.dataItem.pendingRegistrations}</td>)} />
            <GridColumn field="lastActivityDate" title="Last Activity" width="110px" />
            <GridColumn title="Actions" width="100px" sortable={false}
              cell={(props) => (
                <td data-label="Actions">
                  <Button
                    size="small"
                    onClick={() => this.impersonateUser(props.dataItem.id, props.dataItem.email)}
                    title={"Sign in as " + props.dataItem.email}
                  >
                    Login As
                  </Button>
                </td>
              )}
            />
          </Grid>
        </ExcelExport>
      </div>
    );
  }
}
